import { Button, Divider, Form, Select } from 'antd';
import './CustomReportForm.less';
import React, { useRef } from 'react';
import useDownloadPdf from '../hooks/useDownloadPdf';
import SavedReportsSelector from './SavedReportsSelector';
import useGetSortedTemplates from '../hooks/useGetSortedTemplates';

const { Option } = Select;

type Props = {
    templateGuid: string;
    reportGuid: string | undefined;
    reportUrl: string | undefined;
    onReportChange: (templateGuid: string, reportGuid?: string, reportUrl?: string) => void;
};

export default function CustomReportForm({ templateGuid, reportGuid, reportUrl, onReportChange }: Props) {
    const templatesSelectRef = useRef<Select<string>>(null);

    const { sortedTemplates, isLoadingTemplates } = useGetSortedTemplates({ includeDefault: true });

    const { downloadPdf, isLoadingPdfReport } = useDownloadPdf();

    const handleDownloadButtonClicked = () => {
        if (reportGuid && reportUrl) {
            downloadPdf(reportUrl, reportGuid, templateGuid);
        }
    };

    const handleTemplateChange = (newGuid: string) => {
        onReportChange(newGuid, reportGuid, reportUrl);

        if (templatesSelectRef.current) {
            templatesSelectRef.current.blur();
        }
    };

    const handleReportUrlChange = (newUrl: string) => {
        onReportChange(templateGuid, 'latest', newUrl);
    };

    const isDownloadDisabled = !reportGuid || !reportUrl;

    return (
        <div className="white-label-report">
            <div>
                <h2>New Branded PDF Report</h2>
                <div className="form-description">Provide customized professional SEO reports for your clients</div>
            </div>

            <Divider />

            <Form>
                <Form.Item>
                    <div className="form-label">Choose a template</div>
                    <div className="form-description"></div>
                    <Select
                        disabled={isLoadingTemplates}
                        ref={templatesSelectRef}
                        size="large"
                        placeholder="click to select a template"
                        value={templateGuid}
                        onChange={handleTemplateChange}
                    >
                        {sortedTemplates &&
                            sortedTemplates.map((template) => (
                                <Option
                                    key={template.guid}
                                    value={template.guid}
                                >
                                    {template.name}
                                </Option>
                            ))}
                    </Select>
                </Form.Item>

                <Divider />

                <Form.Item>
                    <div className="form-label">Select one of your Saved Reports</div>
                    <div className="form-description"></div>

                    <SavedReportsSelector
                        reportUrl={reportUrl}
                        onReportUrlChange={handleReportUrlChange}
                    />
                </Form.Item>

                <Button
                    type="primary"
                    htmlType="submit"
                    onClick={handleDownloadButtonClicked}
                    disabled={isDownloadDisabled}
                    loading={isLoadingPdfReport}
                >
                    Download
                </Button>
            </Form>
        </div>
    );
}
